@import "../../../globalStyles/commons";

:host {
  display: block;
}

$border-width: 2px;

.menu-item {

  min-height: 2.5rem;
  text-decoration: none;

  cursor: pointer;
  @include font-style(body-compact-01);
  padding-inline: calc(#{v(--spacing-05)} - #{$border-width});
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: v(--spacing-02);
  color: v(--text-secondary);

  border: $border-width solid transparent;

  .item-section {
    display: flex;
    align-items: center;

    &.start {
      width: 1.5rem;
    }
  }

  .slot-main {
    display: block;
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .slot-end {
    color: v(--text-helper);
  }

}

:host-context([size="sm"]) {
  .menu-item {
    min-height: 2rem;
  }
}

:host-context([size="md"]) {
  .menu-item {
    min-height: 2.5rem;
  }
}

:host-context([size="lg"]) {
  .menu-item {
    min-height: 3rem;
  }
}

.menu-item {
  &:hover {
    background: v(--layer-hover);
    color: v(--text-primary);

    .slot-end {
      color: v(--icon-01);
    }
  }

  &.active {
    background: var(--selected-ui);
  }
}

@each $color in [primary, secondary, success, info, warning, error, white, black] {
  .menu-item#{'.color-' + $color} {
    &:hover, &.has-focus:not(.active) {
      background: v(--color-#{$color});
      color: white;

      .slot-end {
        color: white;
      }
    }
  }
}

.menu-item.color-danger {
  &:hover, &.has-focus:not(.active) {
    background: v(--color-error);
    color: white;

    .slot-end {
      color: white;
    }
  }
}

.menu-item.has-focus:not(.active) {
  outline: none;
  border-color: v(--color-primary);
}


.menu-item.disabled {
  cursor: not-allowed;
  color: v(--text-disabled) !important;
  background-color: v(--disabled-01) !important;

  &:hover, &.has-focus:not(.active) {
    color: v(--text-disabled) !important;
    background-color: v(--disabled-01) !important;
  }

  &.active, &.selected {
    color: v(--text-disabled) !important;
    background-color: var(--disabled-01) !important;
  }
}


.menu-item:not(.end-slot-has-content) {
  .slot-end {
    display: none;
  }
}



